import React, { useState, useEffect, useRef } from 'react';

function PopupBtmBookDate({ setisShowBookDate, setisCompleteBookDate, carInfo, setcarInfo }) {
  const [selectedDates, setSelectedDates] = useState(['', '']);
  const [selectedTimes, setSelectedTimes] = useState(['', '']);
  const [activeSection, setActiveSection] = useState(1);
  const [currentMonth, setCurrentMonth] = useState(new Date(2025, 0)); // 2025년 1월
  const [isFormComplete, setIsFormComplete] = useState(false);
  
  // Generate time slots from 10:00 to 16:30 with 30-minute intervals
  const timeSlots = [];
  for (let hour = 10; hour <= 18; hour++) {
    for (let minute of ['00', '30']) {
      if (hour === 18 && minute === '30') continue; // Skip 16:30
      timeSlots.push(`${hour}:${minute}`);
    }
  }

  // Calendar helper functions
  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    return new Date(year, month + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    return new Date(year, month, 1).getDay();
  };

  const generateCalendarDays = () => {
    const daysInMonth = getDaysInMonth(currentMonth);
    const firstDay = getFirstDayOfMonth(currentMonth);
    const days = [];

    // Add empty cells for days before the first day of the month
    for (let i = 0; i < firstDay; i++) {
      days.push(null);
    }

    // Add days of the month
    for (let i = 1; i <= daysInMonth; i++) {
      days.push(i);
    }

    return days;
  };

  // 날짜가 같은지 확인하는 함수
  const isSameDate = (date1, date2) => {
    if (!date1 || !date2) return false;
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  };

  const formatDateDisplay = (date, time) => {
    if (!date || !time) return '';
    const [hour, minute] = time.split(':');
    const hourNum = parseInt(hour);
    const ampm = hourNum >= 12 ? '오후' : '오전';
    const hour12 = hourNum > 12 ? hourNum - 12 : hourNum;
    return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일 ${ampm} ${hour12}:${minute}`;
  };

  // Convert to ISO 8601
  const toISO8601 = (date, time) => {
    if (!date || !time) return '';
    const [hour, minute] = time.split(':');
    const dateObj = new Date(date);
    dateObj.setHours(parseInt(hour), parseInt(minute), 0);
    return dateObj.toISOString();
  };

  const handleDateSelect = (day, index) => {
    if (!day) return;
    const newDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day);
    
    // 두 번째 예약일 선택 시 첫 번째 예약일과 같은 날짜인지 확인
    if (index === 1 && selectedDates[0] && isSameDate(selectedDates[0], newDate)) {
      return; // 같은 날짜면 선택하지 않음
    }
  
    const newDates = [...selectedDates];
    newDates[index] = newDate;
    setSelectedDates(newDates);
  };

  const handleTimeSelect = (time, index) => {
    const newTimes = [...selectedTimes];
    newTimes[index] = time;
    setSelectedTimes(newTimes);
    
    if (index === 0 && time && selectedDates[0]) {
      setActiveSection(2);
    }

    // 두 날짜 모두 선택되었을 때만 완료 설정
    if (selectedDates[0] && selectedDates[1] && newTimes[0] && newTimes[1]) {
      setIsFormComplete(true);
    } else {
      setIsFormComplete(false);
    }
  };

  const handleComplete = () => {
    if (isFormComplete) {
      const updatedCarInfo = {
        ...carInfo,
        carReservationDate: selectedDates.map((date, index) => {
          if (date && selectedTimes[index]) {
            return toISO8601(date, selectedTimes[index]);
          }
          return null;
        }).filter(date => date !== null) // null 값 제거
      };
      setcarInfo(updatedCarInfo);
      setisCompleteBookDate(true);
      setisShowBookDate(false);
    }
  };

  const handleCancel = () => {
    setisShowBookDate(false);
  };


  // PopupBtmBookDate 컴포넌트 내부에 다음 함수 추가
  const getTitle = () => {
    if (selectedDates[0] && selectedTimes[0] && selectedDates[1] && selectedTimes[1]) {
      return "예약일을 확인해주세요";
    } else if (selectedDates[0] && selectedTimes[0]) {
      return "두번째 예약일을 선택해주세요";
    } else {
      return "첫번째 예약일을 선택해주세요";
    }
  };

  const changeMonth = (increment) => {
    const newMonth = new Date(currentMonth);
    newMonth.setMonth(newMonth.getMonth() + increment);
    setCurrentMonth(newMonth);
  };



  // 스와이프 관련 상태
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const dragHandleRef = useRef(null); // 드래그 핸들(상단 바)을 위한 ref

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    // dragHandleRef가 터치 이벤트의 시작점을 포함하고 있는지 확인
    if (dragHandleRef.current?.contains(e.target)) {
      setTouchEnd(null);
      setTouchStart(e.targetTouches[0].clientY);
    }
  };

  const onTouchMove = (e) => {
    // touchStart가 있을 때만 동작 (즉, 드래그 핸들에서 시작된 터치일 때만)
    if (touchStart) {
      setTouchEnd(e.targetTouches[0].clientY);
    }
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchEnd - touchStart;
    const isDownSwipe = distance > minSwipeDistance;
    
    if (isDownSwipe) {
      setisShowBookDate(false);
    }
  };



  return (
    <div className="fixed bg-[rgba(0,0,0,0.7)] top-0 left-0 w-full h-full flex items-end justify-center z-10">
      <div 
        className="bg-white w-full pb-5 pt-10 min-h-64 rounded-t-2xl max-w-screen-md max-h-[calc(100%-67px)] overflow-y-auto relative"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        {/* 드래그 핸들 영역에 ref 추가 */}
        <button 
          ref={dragHandleRef}
          className="absolute top-0 left-0 flex justify-center w-full h-10 pt-4 m-auto rounded-xl"
        >
          <span className="w-10 h-1 bg-[#E1E2E4] rounded-xl"></span>
        </button>

        {/* 제목 */}
        <h3 className="text-[#1B1C1E] text-left font-semibold text-[22px] pl-5 font-semibold w-full">
          {getTitle()}
          <p className="text-[#878A92] text-[16px] mb-4">예약일정은 2개까지 선택 가능합니다.</p>
        </h3>
        
        <div className="">
          
          {/* 예약일 1 */}
          <div className="px-5 mb-4">
            <button 
              className="flex items-center justify-between w-full py-2 text-left text-[15px]"
              onClick={() => setActiveSection(activeSection === 1 ? 0 : 1)}
            >
              <span className="text-[15px]">
                <b className='text-[15px]'>예약일 1</b>
                {selectedDates[0] && selectedTimes[0] 
                  ? ` (${formatDateDisplay(selectedDates[0], selectedTimes[0])})`
                  : ''}
              </span>
              <img 
                src="/assets/img/ico_cal_down.svg" 
                alt="toggle" 
                className={`transform ${activeSection === 1 ? 'rotate-180' : ''}`}
              />
            </button>
            
            {activeSection === 1 && (
              <div className="mt-4">
                {/* Calendar */}
                <div className="mb-4">
                  <div className="flex items-center justify-center gap-[40px] mb-4 font-semibold">
                    <button onClick={() => changeMonth(-1)}><img src="/assets/img/ico_arrow_left.svg" alt="prev" /></button>
                    <span className="font-medium">{currentMonth.getFullYear()}년 {currentMonth.getMonth() + 1}월</span>
                    <button onClick={() => changeMonth(1)}><img src="/assets/img/ico_arrow_right.svg" alt="" /></button>
                  </div>
                  
                  {/* Calendar header */}
                  <div className="grid grid-cols-7 mb-2 text-center text-[15px]">
                    {['일', '월', '화', '수', '목', '금', '토'].map(day => (
                      <div key={day} className="text-sm font-medium">
                        {day}
                      </div>
                    ))}
                  </div>
                  
                  {/* Calendar days */}
                  <div className="grid grid-cols-7 gap-1">
                    {generateCalendarDays().map((day, index) => {
                        const currentDate = day ? new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day) : null;
                        
                        // 선택된 날짜가 현재 보여지는 달의 날짜인지 확인
                        const isSelectedDay = selectedDates[activeSection - 1] && 
                          selectedDates[activeSection - 1].getDate() === day && 
                          selectedDates[activeSection - 1].getMonth() === currentMonth.getMonth() &&
                          selectedDates[activeSection - 1].getFullYear() === currentMonth.getFullYear();
                        
                        // 첫 번째 예약일과 같은 날짜인지 확인
                        const isFirstBookingDate = currentDate && selectedDates[0] && 
                          activeSection === 2 && isSameDate(currentDate, selectedDates[0]);

                      return (
                        <button
                          key={index}
                          className={`h-11 flex items-center justify-center rounded-lg text-[15px] ${
                            isSelectedDay
                              ? 'bg-[#313A4C] text-white'
                              : isFirstBookingDate
                              ? 'bg-[#F4F4F5] text-[#C2C4C8]' // default css 적용
                              : day ? 'hover:bg-gray-100'
                              : ''
                          } ${!day ? 'invisible' : ''}`}
                          onClick={() => {
                            if (isFirstBookingDate) {
                              alert('이미 예약된 날짜입니다');
                              return;
                            }
                            handleDateSelect(day, activeSection - 1);
                          }}
                          disabled={!day}
                        >
                          {day}
                        </button>
                      );
                    })}
                  </div>
                </div>

                {/* Time slots */}
                {selectedDates[0] && (
                  <div>
                    <h4 className="mb-2 font-medium">오전</h4>
                    <div className="grid grid-cols-5 gap-2 mb-4">
                      {timeSlots.filter(time => parseInt(time) < 12).map((time) => (
                        <button
                          key={time}
                          className={`p-2 rounded-lg border ${
                            selectedTimes[0] === time 
                              ? 'bg-[#313A4C] text-white' 
                              : 'border-[#E1E2E4] text-[#1B1C1E]'
                          }`}
                          onClick={() => handleTimeSelect(time, 0)}
                        >
                          {time}
                        </button>
                      ))}
                    </div>
                    
                    <h4 className="mb-2 font-medium">오후</h4>
                    <div className="grid grid-cols-5 gap-2">
                      {timeSlots.filter(time => parseInt(time) >= 12).map((time) => (
                        <button
                          key={time}
                          className={`p-2 rounded-lg border ${
                            selectedTimes[0] === time 
                              ? 'bg-[#313A4C] text-white' 
                              : 'border-[#E1E2E4] text-[#1B1C1E]'
                          }`}
                          onClick={() => handleTimeSelect(time, 0)}
                        >
                          {time}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* 예약일 2 */}
          <div className="mb-4 border-t border-solid border-[#DBDCDF] pt-4 px-5">
            <button 
              className={`flex items-center justify-between w-full py-2 text-left text-[15px] ${
                !selectedDates[0] || !selectedTimes[0] ? 'opacity-50' : ''
              }`}
              onClick={() => {
                if (selectedDates[0] && selectedTimes[0]) {
                  setActiveSection(activeSection === 2 ? 0 : 2)
                }
              }}
              disabled={!selectedDates[0] || !selectedTimes[0]}
            >
              <span className="text-[15px]">
                <b className='text-[15px]'>예약일 2</b>
                {selectedDates[1] && selectedTimes[1] 
                  ? ` (${formatDateDisplay(selectedDates[1], selectedTimes[1])})`
                  : ''}
              </span>
              <img
                src="/assets/img/ico_cal_down.svg" 
                alt="toggle" 
                className={`transform ${activeSection === 2 ? 'rotate-180' : ''}`}
              />
            </button>
            
            {activeSection === 2 && selectedDates[0] && selectedTimes[0] && (
              <div className="mt-4">
                {/* Calendar */}
                <div className="mb-4">
                  <div className="flex items-center justify-center gap-[40px] mb-4 font-semibold">
                    <button onClick={() => changeMonth(-1)}><img src="/assets/img/ico_arrow_left.svg" alt="prev" /></button>
                    <span className="font-medium">{currentMonth.getFullYear()}년 {currentMonth.getMonth() + 1}월</span>
                    <button onClick={() => changeMonth(1)}><img src="/assets/img/ico_arrow_right.svg" alt="" /></button>
                  </div>
                  
                  {/* Calendar header */}
                  <div className="grid grid-cols-7 mb-2 text-center text-[15px]">
                    {['일', '월', '화', '수', '목', '금', '토'].map(day => (
                      <div key={day} className="text-sm font-medium">
                        {day}
                      </div>
                    ))}
                  </div>
                  
                  {/* Calendar days */}
                  <div className="grid grid-cols-7 gap-1">
                    {generateCalendarDays().map((day, index) => {
                        const currentDate = day ? new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day) : null;
                        
                        // 선택된 날짜가 현재 보여지는 달의 날짜인지 확인
                        const isSelectedDay = selectedDates[activeSection - 1] && 
                          selectedDates[activeSection - 1].getDate() === day && 
                          selectedDates[activeSection - 1].getMonth() === currentMonth.getMonth() &&
                          selectedDates[activeSection - 1].getFullYear() === currentMonth.getFullYear();
                        
                        // 첫 번째 예약일과 같은 날짜인지 확인
                        const isFirstBookingDate = currentDate && selectedDates[0] && 
                          activeSection === 2 && isSameDate(currentDate, selectedDates[0]);

                      return (
                        <button
                          key={index}
                          className={`h-11 flex items-center justify-center rounded-lg text-[15px] ${
                            isSelectedDay
                              ? 'bg-[#313A4C] text-white'
                              : isFirstBookingDate
                              ? 'bg-[#F4F4F5] text-[#C2C4C8]' // default css 적용
                              : day ? 'hover:bg-gray-100'
                              : ''
                          } ${!day ? 'invisible' : ''}`}
                          onClick={() => {
                            if (isFirstBookingDate) {
                              alert('이미 예약된 날짜입니다');
                              return;
                            }
                            handleDateSelect(day, activeSection - 1);
                          }}
                          disabled={!day}
                        >
                          {day}
                        </button>
                      );
                    })}
                  </div>
                </div>

                {/* Time slots */}
                {selectedDates[1] && (
                  <div>
                    <h4 className="mb-2 font-medium">오전</h4>
                    <div className="grid grid-cols-5 gap-2 mb-4">
                      {timeSlots.filter(time => parseInt(time) < 12).map((time) => (
                        <button
                          key={time}
                          className={`p-2 rounded-lg border ${
                            selectedTimes[1] === time 
                              ? 'bg-[#313A4C] text-white' 
                              : 'border-[#E1E2E4] text-[#1B1C1E]'
                          }`}
                          onClick={() => handleTimeSelect(time, 1)}
                        >
                          {time}
                        </button>
                      ))}
                    </div>
                    
                    <h4 className="mb-2 font-medium">오후</h4>
                    <div className="grid grid-cols-5 gap-2">
                      {timeSlots.filter(time => parseInt(time) >= 12).map((time) => (
                        <button
                          key={time}
                          className={`p-2 rounded-lg border ${
                            selectedTimes[1] === time 
                              ? 'bg-[#313A4C] text-white' 
                              : 'border-[#E1E2E4] text-[#1B1C1E]'
                          }`}
                          onClick={() => handleTimeSelect(time, 1)}
                        >
                          {time}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="flex justify-between gap-[10px] border-t border-solid border-[#DBDCDF] pt-5 px-5">
          <button
            className="flex items-center justify-center w-full h-[52px] rounded-lg bg-[#F4F4F5] text-[#313A4C] font-semibold"
            onClick={() => handleCancel()}
          >
            취소
          </button>
          <button
            className={`flex items-center justify-center w-full h-[52px] rounded-lg ${
              isFormComplete ? 'bg-[#313A4C] text-white' : 'bg-[#F4F4F5] text-[#C2C4C8]'
            } cursor-pointer font-semibold`}
            onClick={handleComplete}
            disabled={!isFormComplete}
          >
            완료
          </button>
        </div>
      </div>
    </div>
  );
}

export default PopupBtmBookDate;